//External
import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import dynamic from "next/dynamic";
import ReactHtmlParser from "react-html-parser";
// import YouTube from "react-youtube";
const YouTube = dynamic(() => import("react-youtube"));

/*******************
   @Purpose : Used for home bottom
   @Parameter : {}
   @Author : INIC
  *******************/
function HomeBottom({ data }) {
  const [show, toggleClass] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [titlePart1, setTitlePart1] = useState();
  const [titlePart2, setTitlePart2] = useState();
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowVideo(true);
    }, 100);

    setTimeout(() => {
      const video = document.getElementById("mobileVideoId");
      if (video) {
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
      }
    }, 200);

    let str;
    let len;
    let firstPart = [];
    let secondPart = [];

    if (data?.bottom_title) {
      str = data?.bottom_title?.split(" ");
      len = str?.length;
      if (data?.bottom_title?.toLowerCase().includes("miami")) {
        /*
        for (let i = 0; i < len - 1; i++) {
          firstPart.push(str[i]);
        }
        secondPart.push(str[len - 1]);
        */
        setTitlePart1(data?.bottom_title);
        setTitlePart2("");
      } else {
        for (let i = 0; i < len - 2; i++) {
          firstPart.push(str[i]);
        }
        secondPart.push(str[len - 2]);
        secondPart.push(str[len - 1]);
        setTitlePart1(firstPart.join(" "));
        setTitlePart2(secondPart.join(" "));
      }
    }
    if (window.screen.width > 740) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }

    if (window.screen.width > 1024) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }, [data]);

  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {data?.bottom_title && (
        <section className="exotic-car py-75 border-thick-bottom">
          <div className="custom-container">
            {isMobile && (
              <div className="section-heading">
                <h3 className="mb-0">The Experience</h3>
              </div>
            )}
            <div
              className={`exotic-wrapper position-relative ${
                show ? "active" : ""
              }`}
            >
              {/* {data?.bottom_img_url && showVideo && (
                <div className="exotic-video">
                  <div className="video-wrap">
                    <YouTube
                      className="home-youtube-video"
                      videoId={data?.bottom_img_url.split("/").pop()}
                      id={data?.bottom_img_url.split("/").pop()}
                    />
                  </div>
                </div>
              )} */}

              {data?.desktop_video &&
                showVideo &&
                !isMobile &&
                data?.desktop_video_thumbnail && (
                  <div className="exotic-video">
                    <div className="video-wrap">
                      <video
                        width="320"
                        height="240"
                        poster={data?.desktop_video_thumbnail}
                        controls
                      >
                        <source src={data?.desktop_video} type="video/mp4" />
                      </video>
                    </div>
                  </div>
                )}

              {data?.mobile_video &&
                showVideo &&
                isMobile &&
                data?.mobile_video_thumbnail && (
                  <div className="exotic-video">
                    <div className="video-wrap">
                      <video
                        id="mobileVideoId"
                        width="320"
                        height="240"
                        poster={data?.mobile_video_thumbnail}
                        controls
                      >
                        <source src={data?.mobile_video} type="video/mp4" />
                      </video>
                    </div>
                  </div>
                )}

              {data?.bottom_content && (
                // <div className="exotic-content overflow-hidden">

                <div
                  className={`exotic-content overflow-hidden ${
                    isDesktop ? "without-youtube-web" : ""
                  }`}
                >
                  <div className="exotic-heading mt-4 mt-lg-0 mw-100 w-100 d-sm-block">
                    <h2 className="mb-0 d-flex flex-wrap">
                      <span className="mr-2">{titlePart1}</span>
                      <span>{titlePart2}</span>
                    </h2>
                  </div>
                  {ReactHtmlParser(data?.bottom_content)}
                </div>
              )}

              <Button
                variant="link"
                className="read-more border-0 bg-transparent text-primary"
                onClick={() => toggleClass(true)}
              >
                Read more <span className="icon icon-chevron-right"></span>
              </Button>
              <Button
                variant="link"
                className="read-more read-less border-0 bg-transparent text-primary"
                onClick={() => toggleClass(false)}
              >
                Read less <span className="icon icon-chevron-right"></span>
              </Button>
            </div>
          </div>
        </section>
        
      )}
    </>
  );
}

export default HomeBottom;
